import Vue from "vue";

export default {
  SET_MODE(state, data) {
    state.mode = data;
  },

  SET_MAP_STYLE(state, data) {
    state.mapStyle = data;
  },

  SET_VESSEL(state, data) {
    state.vessel = data;
  },

  SET_VESSEL_LIVE_POSITION(state, data) {
    state.vesselLivePosition = data;
  },
  SET_VESSEL_LIVE_AIS_INFO(state, data) {
    state.vesselLiveAisInfo = data;
  },

  SET_VESSEL_PICTURES(state, data) {
    state.vesselPictures = data;
  },

  SET_COUNTRY_CODE(state, data) {
    state.countryCodes = data;
  },

  SET_CAMERA_SELECT_OPTIONS(state, payload) {
    state.cameraSelectOptions = payload.options;
  },

  SET_DOCUMENTS_LIST(state, payload) {
    state.documentsList = payload.documentsList;
  },

  SET_VOYAGE_HISTORY_DATE_TIME(state, data) {
    state.voyageHistoryDateTime = data;
  },

  SET_VOYAGE_HISTORIES(state, data) {
    state.voyageHistories = data;
  },

  SET_VESSEL_POSITION_EXPIRED_10MIN(state, data) {
    state.vesselPositionExpired10min = data;
  },

  RESET_STATE (state, data) {
    Object.assign(state, data)
  },

  SET_VESSEL_LIVE_DATA(state, payload) {
    state.vesselLiveData.push(payload.vesselLiveData);
    //state.vesselLiveData = payload
  },

  CLEAR_VESSEL_LIVE_DATA(state) {
    state.vesselLiveData = []
  },

  ADD_FIRESTORE_SUBSCRIBE_LIST(state, data) {
    state.firestoreSubscribeList.push(data);
  },

  UNSUBSCRIBE_FIRESTORE(state) {
    if (state.firestoreSubscribeList.length > 0) {
      state.firestoreSubscribeList.forEach(unsubscribe => {
        unsubscribe();
      });
    }
  },  

  UPDATE_LIVE_DATA_VALUE_MAP(state, payload) {
    Vue.set(state.liveDataValueMap, payload.versionName + "/" + payload.channelId, payload.value)
  },

  SET_KIND_ORIGIN_VERSION_MAP(state, payload) {
    if (!state.kindOriginVersionMap[payload.kind]) state.kindOriginVersionMap[payload.kind] = {}
    state.kindOriginVersionMap[payload.kind][payload.origin.toString()] = payload.version
  },

  SET_CHANNEL_UNIT_MAP(state, payload) {
    if (!state.channelUnitMap[payload.versionId]) state.channelUnitMap[payload.versionId] = {}
    state.channelUnitMap[payload.versionId][payload.channelId.toString()] = payload.unit
  }
}
